/**
 * Store registry — Rammeverket (B): framework stores shared by all products.
 * Part of the product-composition layer: app.js merges the three registries
 * (core + dyrejournal + other) into this.stores. Key names must stay exactly
 * as components expect them via props.stores.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
// Partner visits API (2026-10-06): see docs/superpowers/specs/2026-10-06-partner-visits-api-design.md

import appState from '../stores/appState';
import tableStore from '../stores/table';
import versionStore from '../stores/version';
import userStore from '../stores/user';
import mediaStore from '../stores/media';
import customerStore from '../stores/customer';
import usageStore from '../stores/usage';

import saleStore from '../stores/sale';
import salePaymentStore from '../stores/salePayment';
import visitorCreditStore from '../stores/visitorCredit';
import saleReportStore from '../stores/saleReport';
import productStore from '../stores/product';
import fileStore from '../stores/file';

import contactStore from '../stores/contact';
import dealerStore from '../stores/dealer';
import productListStore from '../stores/productList';
import pricelistStore from '../stores/pricelist';

import calendarStore from '../stores/calendar';
import calendarEventStore from '../stores/calendarEvent';
import calendarAvailabilityStore from '../stores/calendarAvailability';
import textTemplateStore from '../stores/textTemplate';
import pricingSettingStore from '../stores/pricingSetting';
import calendarTemplateStore from '../stores/calendarTemplate';
import smsStore from '../stores/sms';
import mailSentStore from '../stores/mailSent';
import pushLogStore from '../stores/pushLog';

import paymentStore from '../stores/payment';
import vippsStore from '../stores/vipps';
import guestCartStore from '../stores/guestCart';
import paypalStore from '../stores/paypal';

import fikenStore from '../stores/fiken';
import tripletexStore from '../stores/tripletex';
import powerofficeStore from '../stores/poweroffice';
// Breece: part of Dyrejournal (decided 2026-07-05; § 4.5 ⇒ A, pending
// Vedlegg 1 Del E entry). Registry placement follows the Vedlegg 1 entry.
import breeceStore from '../stores/breece';

// Article backend/store is part of the Dyrejournal build (help center —
// decision 2026-07-05, manifest §9; propose B in Vedlegg 1). The CMS/
// marketplace/feed UI that also uses this store remains C and excluded.
import articleStore from '../stores/article';
import helpSearchStore from '../stores/helpSearch';
import articleFeedbackStore from '../stores/articleFeedback';

import likeStore from '../stores/like';
import commentStore from '../stores/comment';
import pollStore from '../stores/poll';
import messageStore from '../stores/message';
import presenceStore from '../stores/presence';
import supportTicketStore from '../stores/supportTicket';
import supportAiChatStore from '../stores/supportAiChat';
import blockedUserStore from '../stores/blockedUser';
import aiFeedbackStore from '../stores/aiFeedback';

import documentStore from '../stores/document';
import apiTokenStore from '../stores/apiToken';
import adminApiTokenStore from '../stores/adminApiToken';
import oauthClientAdminStore from '../stores/oauthClientAdmin';
import mcpProposalStore from '../stores/mcpProposal';
import adminFeatureUsageStore from '../stores/adminFeatureUsage';
// Signing/NDA stores live in stores-signing.js (B✕ — excluded from the
// Dyrejournal build; decision 2026-07-05, manifest §9).
import imageBrowserStore from '../stores/imageBrowser';
import commissionStore from '../stores/commission';

export default {
    appState,
    tableStore,
    versionStore,
    userStore,
    mediaStore,
    customerStore,
    usageStore,

    saleStore,
    salePaymentStore,
    visitorCreditStore,
    saleReportStore,
    productStore,
    fileStore,

    contactStore,
    dealerStore,
    productListStore,
    pricelistStore,

    calendarStore,
    calendarEventStore,
    calendarAvailabilityStore,
    textTemplateStore,
    pricingSettingStore,
    calendarTemplateStore,
    smsStore,
    mailSentStore,
    pushLogStore,

    paymentStore,
    vippsStore,
    guestCartStore,
    paypalStore,

    fikenStore,
    tripletexStore,
    powerofficeStore,
    breeceStore,

    articleStore,
    helpSearchStore,
    articleFeedbackStore,

    likeStore,
    commentStore,
    pollStore,
    messageStore,
    presenceStore,
    supportTicketStore,
    supportAiChatStore,
    blockedUserStore,
    aiFeedbackStore,

    documentStore,
    apiTokenStore,
    adminApiTokenStore,
    oauthClientAdminStore,
    mcpProposalStore,
    adminFeatureUsageStore,
    imageBrowserStore,
    commissionStore,
};
